import type { ButtonHTMLAttributes } from 'react'

type Variant = 'primary' | 'secondary' | 'ghost'

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: Variant
}

export default function Button(props: ButtonProps) {
  const { variant = 'primary', className, ...rest } = props
  const base =
    'inline-flex items-center justify-center rounded-full px-6 py-3 text-sm font-semibold transition focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/40'
  const variants: Record<Variant, string> = {
    primary: 'bg-primary text-black hover:bg-[#12d584]',
    secondary: 'bg-secondary/20 text-white hover:bg-secondary/30 border border-white/10',
    ghost: 'border border-white/10 bg-white/5 text-white/85 hover:bg-white/10 hover:text-white',
  }
  return <button {...rest} className={[base, variants[variant], className].filter(Boolean).join(' ')} />
}

